import React, { FunctionComponent } from "react";

import { Stack, useTheme } from "@bps/fluent-ui";
import { withPermissions } from "@components/withPermissions";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { Permissions } from "@libs/permissions/permissions.enum";

import { TenantUsersAuthTabsWrapper } from "./components/TenantUsersAuthTabsWrapper";

export interface TenantUsersAuthProps {
  tenant: Tenant;
}

const TenantUsersAuthBase: FunctionComponent<TenantUsersAuthProps> = ({
  tenant: { id: tenantId }
}) => {
  const theme = useTheme();

  return (
    <Stack
      verticalFill
      styles={{ root: { padding: theme.spacing.s1 } }}
      tokens={{ childrenGap: theme.spacing.l2 }}
    >
      <Stack.Item grow styles={{ root: { overflowY: "auto" } }}>
        <TenantUsersAuthTabsWrapper tenantId={tenantId} />
      </Stack.Item>
    </Stack>
  );
};

export const TenantUsersAuth = withPermissions(
  TenantUsersAuthBase,
  [Permissions.PltCatalogTenantRead, Permissions.PltCatalogTenantWrite],
  "or"
);
